import { render } from "./HeroClaim.vue?vue&type=template&id=7f328ee4&scoped=true"
const script = {}

import "./HeroClaim.vue?vue&type=style&index=0&id=7f328ee4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f328ee4"]])

export default __exports__